import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { getDoc, doc, collection, DocumentSnapshot } from "firebase/firestore"
import { db } from "../firebase"

export const BreadcrumbsIndividual = () => {
  const { individualId } = useParams()
  const [individualNo, setIndividualNo] = useState<string>('')
  const individualsRef = collection(db, "individuals")

  useEffect(() => {
    getDoc(doc(individualsRef, individualId)).then((doc: DocumentSnapshot) => {
      doc.exists() && setIndividualNo(doc.data().individualNo)
    })
  })

  return <>{individualNo ? individualNo : "-"}</>;
};
